module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "register-login"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    attrs: {
      "type": "password",
      "name": "pwd",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "btn-section"
  }, [_c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("确认")])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("用户登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "#/regist"
    }
  }, [_vm._v("没有账号？点此处注册")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c277af2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 626
// module chunks = 1